<template>
	<base-content navIndex="1">
		<div class="index-header">
			<div class="header-content flex align-c justify-sb">
				<div class="flex align-c">
					<el-image class="job-icon"
						:src="require('@/assets/images/index/hxek.png')"></el-image>
					<div>
						<div class="job-title col-fff bold">鸿星尔克</div>
						<div class="job-sub col-fff">已上市·10000人以上·电子商务</div>
					</div>
				</div>
				<div class="flex align-e">
					<div class="job-big col-fff bold">91</div>
					<div class="job-small col-fff">在招职位</div>
					<div class="job-big col-fff bold">52</div>
					<div class="job-small col-fff">线上课程</div>
				</div>
			</div>
		</div>
		<div class="bg-lin-ef">
			<div class="width-1280 job-lin">
				<div class="job-tabs bg-fff">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="公司简介" name="first">公司简介</el-tab-pane>
						<el-tab-pane label="岗位招聘(91)" name="second">
							<recruitModule></recruitModule>
						</el-tab-pane>
						<el-tab-pane label="线上课程(52)" name="third">线上课程(52)</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
	</base-content>
</template>

<script>
	import baseContent from '@/components/base-content.vue'
	import recruitModule from './components/recruit-module.vue'
	export default{
		components:{ baseContent,recruitModule },
		data(){
			return{
				activeName:'second',
				
			}
		},
		mounted() {
			
		},
		methods:{
			handleClick(){
				
			}
		}
	}
</script>

<style>
	.index-header{
		background: #39546A;
		height: 148px;
	}
	.header-content{
		width: 1280px;
		margin: auto;
		padding: 0 20px;
		height: 100%;
	}
	.job-icon{
		width: 70px;
		height: 70px;
		border-radius: 4px;
		margin-right: 28px;
	}
	.job-title{
		font-size: 32px;
		line-height: 45px;
		margin-bottom: 4px;
	}
	.job-sub{
		font-size: 14px;
		line-height: 20px;
	}
	.job-big{
		font-size: 45px;
		line-height: 50px;
		margin: 0 10px 0 28px;
	}
	.job-small{
		font-size: 14px;
		line-height: 20px;
	}
	.job-lin{
		height: 636px;
		padding: 16px 20px 0 20px;
	}
	.job-tabs{
		height: 52px;
		border-radius: 12px;
	}
	.job-tabs .el-tabs__nav-wrap::after{
		background: transparent;
	}
	.job-tabs .el-tabs__item{
		height: 52px;
		line-height: 52px;
		font-weight: bold;
		font-size: 18px;
	}
	.job-tabs .el-tabs__item.is-active{
		color: #169BD5 !important;
	}
	.job-tabs .el-tabs__item:hover{
		color: #169BD5 !important;
	}
	.job-tabs .el-tabs__active-bar{
		height: 3px !important;
	}
	.job-tabs #tab-first{
		padding-left: 26px;
	}
</style>